<template>
    <external-list
            :headlines="[{text: 'Text', width: 5}, {text: 'URL', width: 5}]"
            endpoint="/api/v2/marketing-site-menu-items"
            :endpoint-filters="{portal_id: portal.id, language: language, location: 'top'}"
            :can-destroy="() => true"
            reorder-endpoint="/api/v2/marketing-site-menu-items/priorities"
            :get-reorder-payload="data => ({marketing_site_menu_items: data})"
            @show="edit"
    >
        <template v-slot:default="{ row: menuItem }">
            <td>
                <a href="#" @click.prevent="edit(menuItem)">
                    {{ menuItem.attributes.text }}
                </a>

                <span v-if="menuItem.attributes.is_highlighted" class="label label-success">
                    Highlighted
                </span>
            </td>

            <td>
                {{ menuItem.attributes.url }}
            </td>
        </template>

        <template v-slot:modals="{ load, update }">
            <create-modal :portal="portal" :language="language" @created="load"/>

            <edit-modal :menu-item="editing" @updated="update"/>
        </template>
    </external-list>
</template>

<script>
    import CreateModal from '@/components/Modals/Administration/MarketingSites/TopMenuItems/Create'
    import EditModal from '@/components/Modals/Administration/MarketingSites/TopMenuItems/Edit'
    import ExternalList from '@/components/Panels/Lists/External'

    export default {
        components: {CreateModal, EditModal, ExternalList},

        props: {
            portal: {
                required: true
            },

            language: {
                required: true
            }
        },

        data() {
            return {
                editing: null
            }
        },

        methods: {
            edit(menuItem) {
                this.editing = menuItem

                $('#edit-marketing-site-top-menu-item-modal').modal('toggle')
            }
        }
    }
</script>

